import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';
const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'ConnectSourcesGuides',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build: ({ guideIds }) => {
        const pipeline = o.pipeline(
            o.sources.guides({
                appId: 'expandAppIds("*")',
            }),
            o.filter(guideIds.map((guideId) => `id == "${guideId}"`).join(' || ')),
            o.select({
                id: 'id',
                name: 'name',
                polls: 'polls',
                appId: 'appId',
                group: 'group',
                createdAt: 'createdAt',
            }),
        );

        return pipeline;
    },
};
